import { render, staticRenderFns } from "./bi-title.vue?vue&type=template&id=3509c829&scoped=true"
import script from "./bi-title.vue?vue&type=script&lang=js"
export * from "./bi-title.vue?vue&type=script&lang=js"
import style0 from "./bi-title.vue?vue&type=style&index=0&id=3509c829&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3509c829",
  null
  
)

export default component.exports